export const MODULES = [
  {
    path: "documents", title: "Documents", module: "documents", endpoint: "/documents",
    subtitle: "Secure organizational documents and records.",
    columns: [
      { key: "name", label: "Name" }, { key: "type", label: "Type" },
      { key: "category", label: "Category" }, { key: "status", label: "Status", type: "badge" },
      { key: "created_at", label: "Added", type: "date" },
    ],
    fields: [
      { key: "name", label: "Name", required: true }, { key: "type", label: "Type" },
      { key: "category", label: "Category" }, { key: "expiry_date", label: "Expiry Date" },
      { key: "status", label: "Status", type: "select", options: ["ACTIVE", "EXPIRED", "ARCHIVED"] },
    ],
  },
  {
    path: "fleet", title: "Fleet & Vehicles", module: "fleet", endpoint: "/vehicles",
    subtitle: "Vehicles, capacity, and accessibility across the fleet.",
    columns: [
      { key: "code", label: "Code" }, { key: "name", label: "Vehicle" },
      { key: "make", label: "Make" }, { key: "year", label: "Year" },
      { key: "license_plate", label: "Plate" }, { key: "status", label: "Status", type: "badge" },
    ],
    fields: [
      { key: "code", label: "Fleet Code", required: true }, { key: "name", label: "Name" },
      { key: "make", label: "Make" }, { key: "model", label: "Model" },
      { key: "year", label: "Year", type: "number" }, { key: "vin", label: "VIN" },
      { key: "license_plate", label: "License Plate" }, { key: "capacity", label: "Capacity", type: "number" },
      { key: "status", label: "Status", type: "select", options: ["ACTIVE", "MAINTENANCE", "INACTIVE"] },
    ],
  },
  {
    path: "trips", title: "Trips", module: "trips", endpoint: "/trips",
    subtitle: "Scheduled and completed transportation trips.",
    columns: [
      { key: "title", label: "Trip" }, { key: "client_name", label: "Client" },
      { key: "pickup", label: "Pickup" }, { key: "status", label: "Status", type: "badge" },
      { key: "scheduled_at", label: "Scheduled", type: "date" },
    ],
    fields: [
      { key: "title", label: "Title", required: true }, { key: "client_name", label: "Client" },
      { key: "pickup", label: "Pickup" }, { key: "dropoff", label: "Dropoff" },
      { key: "scheduled_at", label: "Scheduled At" },
      { key: "status", label: "Status", type: "select", options: ["SCHEDULED", "IN_PROGRESS", "COMPLETED", "CANCELLED"] },
    ],
  },
  {
    path: "maintenance", title: "Maintenance", module: "maintenance", endpoint: "/vehicle-maintenance",
    subtitle: "Service schedules and vehicle maintenance alerts.",
    columns: [
      { key: "type", label: "Service" }, { key: "status", label: "Status", type: "badge" },
      { key: "due_date", label: "Due", type: "date" }, { key: "notes", label: "Notes" },
    ],
    fields: [
      { key: "type", label: "Service Type", required: true }, { key: "notes", label: "Notes", type: "textarea" },
      { key: "due_date", label: "Due Date" },
      { key: "status", label: "Status", type: "select", options: ["SCHEDULED", "DUE", "OVERDUE", "DONE"] },
    ],
  },
  {
    path: "tasks", title: "Tasks & Follow-ups", module: "tasks", endpoint: "/tasks",
    subtitle: "Your assigned work and automated follow-ups.",
    columns: [
      { key: "title", label: "Task" }, { key: "type", label: "Type", type: "badge" },
      { key: "priority", label: "Priority", type: "badge" }, { key: "status", label: "Status", type: "badge" },
      { key: "due_date", label: "Due", type: "date" },
    ],
    fields: [
      { key: "title", label: "Title", required: true },
      { key: "type", label: "Type", type: "select", options: ["TASK", "FOLLOWUP"] },
      { key: "priority", label: "Priority", type: "select", options: ["LOW", "MEDIUM", "HIGH"] },
      { key: "due_date", label: "Due Date" },
      { key: "status", label: "Status", type: "select", options: ["OPEN", "IN_PROGRESS", "DONE"] },
    ],
  },
  {
    path: "notifications", title: "Notifications", module: "notifications", endpoint: "/notifications",
    subtitle: "System alerts and operational notifications.",
    columns: [
      { key: "title", label: "Title" }, { key: "type", label: "Type", type: "badge" },
      { key: "message", label: "Message" }, { key: "created_at", label: "When", type: "date" },
    ],
    fields: [
      { key: "title", label: "Title", required: true }, { key: "message", label: "Message", type: "textarea" },
      { key: "type", label: "Type", type: "select", options: ["SYSTEM", "INQUIRY", "TRIP", "MAINTENANCE"] },
    ],
  },
];
